export default __webpack_public_path__ + "static/B0131-6658e271f6a963dcca2d5c90da85f654.png";